export const content = {
    base_info: {

    },
    menu: {
        item: ['了解NEST','产品', '设计工艺','店铺', '联系我们']
    },
    footer:[
        '属于特雷通集团',
        '版权所有 2019-2029',
        '沪ICP 备07004433 号-12'
    ],
    home: {
        topTitle: '来自丹麦的幸福',
        about: '了解NEST',
        list: [
            ['沙发', '探索更多沙发'],
            ['床具', '探索更多床'],
            ['椅子', '探索更多椅子'],
            ['家具', '探索更多家具']
        ],
        panel: [
            ['纯正丹麦设计','', '中国制造', '高品质天然材质，', '融合功能性和美感，', '不仅仅是色彩和面料的灵感碰撞', '获取灵感'],
            ['门店获取', '专属设计服务', '每一件产品都兼具耐用', '性和舒适性，让家居生', '活成为心灵的归属', '联系我们']
        ],
        content: [
            [
                '缔造风格/营造HYGGE/铸就幸福',
                'NEST将纯正的丹麦设计和天然材料将这份纯粹注入您的居家空间，专注于提升您家庭生活的舒适感与幸福感。我们匠心打造的每一件产品，兼具经久不衰的优雅造型和实用主义之美，塑造了宁静与愉悦的家居氛围。',
                "NEST品牌为挑剔的中国消费者提供的家具，完美融合了北欧设计和中国制造 ，丹麦语的“Hygge”理念在您家得以延伸，您可以感受到无尽舒适和惬意，真正感受来自丹麦的幸福。",
                ''],
            [
                '来自丹麦的幸福',
                'NEST作为丹麦设计的代表，将纯正的北欧设计与理念融入您的生活空间，为您的家带来别样的舒适与宁静。',
                '我们的产品融合功能性和美感，让家成为您心灵的归宿。']
        ],
    },
    design: {
        topTitle: '设计工艺',
        tPanel:['NOORUM丹麦设计团队','NEST的产品开发与设计创新来自丹麦优秀的家居设计师，他们年轻且对工作充满激情，同时拥有丰富的创造力与想象力，他们在新技术、新材料、新生活方式探索基础上，创造出了许多现代丹麦设计家居产品。然而，更重要的是我们对丹麦设计的诠释:质朴、优雅，功能性和耐用性。'],
        content: [
            [
                '纯正的丹麦设计',
                '丹麦式匠心工艺所体现出历久弥新的美学价值，激发了我们不同产品系列的创意灵感。',
                '从客厅、卧室、到餐厅，我们每个产品系列都以干净的线条，实用性的产品设计理念，以及极简之美传承了丹麦设计中最珍贵的简约和优雅。',
                '我们的每一件产品都是艺术品，把富有远见卓识的丹麦设计师们的巧思，经由技艺娴熟的匠人之手打造呈现。'
            ],
            [
                '天然材料',
                '天然皮革/天然木材/天然石材',
                '硬木与胶合板框架',
                '欧盟零甲醛认证',
                '低排放泡沫与纤维',
                '碳中和制造',
                '',
            ],
            [
                '极致舒适',
                '国际级人体工程学设计',
                '高密度高回弹海绵',
                '顶级中空共轭聚酯纤维',
                '羽绒填充靠背',
                '多功能调节与腰部支撑',
                '持久耐用框架',
                '',
                '',
                '',
                ''
            ]
        ]
    },
    contact:{
        topTitle: '联系我们',
        email: {
            title: '联系我们',
            placeholder: [
                '您的国家/城市',
                '您从何处了解到我们？',
                '您的姓名',
                '电子邮箱',
                '手机号码',
                '您的留言内容',
                '发送'
            ]
        }
    },
    about:{
        topTitle: '品牌故事',
        content:[
            [
                '丹麦籍的Simon Lichtenberg是NEST空间品牌创始人。',
                '1993年，源于对北欧设计的热情驱动着Simon，使他踏上了前往中国的变革之旅。他是将北欧高端生活方式带入中国的第一人，并于1997年在上海开始实业投资，生产制造丹麦设计为主的软体家具，推动了中国家居行业的创新与发展，引导了中国消费者对现代生活方式理念的认知与追求。',
                'Simon Lichtenberg 李曦萌',
                '品牌创始人'
            ],
            [
                '设施',
                '我们在美国北卡罗莱纳州的高点、墨西哥的瓜达拉哈拉市、越南的胡志明市，以及中国的香港、上海市和浙江省嘉兴市，均设有办公室。目前员工总人数约为2,000人，运营管理的4家工厂分别位于中国、越南和墨西哥，总厂房面积约为20万平方米。我们是行业内拥有最高生产力的企业之一，也是高品质和高效配送的最佳纪录保持者之一。'
            ],
            [
                '空间',
                'NEST 空间 ® 是我们的主要国际品牌，包括客厅、卧室和餐厅家具，以优质皮革和织物产品为核心，在中国设计和制造并销售给世界各地的家具零售商。',
                '该品牌由特雷通集团于 2020年创立，专注于开发、营销和分销具有北欧灵感的精心设计的现代家具。NEST 空间 ® 软体家具产品全部由位于中国浙江省嘉兴市秀州区的特雷通总部工厂自行生产。我们提供皮革和布类产品的颜色定制，并且高效交付。',
                '我们在全球多个国家和地区经营着自己的零售网络 NEST 空间 ® 零售店（包括自营店和特许经营店），目标客群是快速增长的现代城市中产阶级。',
            ],
            [
                '研发实力',
                '经过30年的沙发制造历程，我们发展并提炼出了一套独特有效的新品开发方法，贯穿于调研、构想、设计、工艺等各环节。我们在快节奏、标准化、结构化的研发过程中，成功运用了各种新颖，现代且有效的三维数字化工具。我们致力于使用最先进的技术，生产行业内质量上乘、性价比极高的产品。',
                '卓越品质 专注细节',
                '引领技术革新，行业顶尖的软体家具团队创造出风格新颖的面料缝纫工艺及款式，是我们产品的一大关键特色，也是品牌始终引以为豪的特点。持续不断的业务改进（生产设备、生产布局、流程控制、产能优化、标准化和自动化）促成了最终各类高标准的达成。',
                '我们一贯保持优质的行业内最高品质要求，客诉率远低于0.5%。',
            ],
            [
                '可持续发展',
                'UNGC 联合国契约',
                '2023年10月，在中国上海举行的“加速前进”CEO圆桌会议上，特雷通集团创始人兼CEO Simon Lichtenberg 与联合国全球契约组织（UNGC）副秘书长兼执行主任 Sanda Ojiambo 女士会面，探讨企业在全球可持续发展中的责任与机遇。',
                '作为国内最早加入联合国全球契约组织（UNGC）的企业之一，特雷通集团于2023年成功完成青年专业人才SDG创新加速器项目，并于2024年顺利通过气候雄心企业加速器（CAA）项目，持续深化可持续发展实践。',
                'SBTi 科学碳目标倡议',
                '2024年5月，特雷通成功通过 SBTi 官方验证，成为中国首家获此认证的家具企业。这一里程碑标志着特雷通在气候行动领域迈出了重要一步，坚定践行基于科学的碳减排和可持续发展承诺。',
            ]
        ]
    },
    video:{
        topTitle: '店铺',
        title:'我们在全球多个国家和地区经营着自己的零售网络 NEST 空间 ® 零售店（包括自营店和特许经营店），目标客群是快速增长的现代城市中产阶级。'
    },
    product:{
        topTitle: '产品',
    }
}